<section class="main-content-wrapper">
  <div class="watermark" *ngIf="
      PLoanDetail &&
      PLoanDetail.Watermark_Status &&
      PLoanDetail.Watermark_Status == 'Closed'
    ">
    Closed
  </div>
  <!-- <div class="row m-0 mt-4" *ngIf="loanSummary">
    <div class="col-md-3">
      <h6 class="fs-12">Application No</h6><p class="lead fs-12">{{ loanSummary.ApplicationNo }}</p>
    </div>
    <div class="col-md-3">
      <h6 class="fs-12">Branch</h6><p class="lead fs-12">{{ loanSummary.Branch }}</p>
    </div>
    <div class="col-md-3">
      <h6 class="fs-12">Loan Product</h6><p class="lead fs-12">{{ loanSummary.Product }}</p>
    </div>
    <div class="col-md-3">
      <h6 class="fs-12">Borrower Name</h6><p class="lead fs-12">{{ loanSummary.Customer }}</p>
    </div>
    <div class="col-md-3">
      <h6 class="fs-12">Loan Amount </h6><p class="lead fs-12">₹{{ loanSummary.LoanAmount }}</p>
    </div>
    <div class="col-md-3">
      <h6 class="fs-12">Tenure</h6><p class="lead fs-12">{{ loanSummary.Tenure }} Months</p>
    </div>
    <div class="col-md-3">
      <h6 class="fs-12">Loan No</h6><p class="lead fs-12">{{ loanSummary.LoanNo }}</p>
    </div>
    <div class="col-md-3">
      <h6 class="fs-12">Loan Date</h6><p class="lead fs-12">{{ loanSummary.LoanDate }}</p>
    </div>
  </div> -->
  <div *ngIf="loanSummary"
    [ngClass]="PLoanDetail && PLoanDetail.Watermark_Status != null && PLoanDetail.Watermark_Status != undefined ? 'alert alert-danger' : ''">
    
    <!-- Top summary card (shown if Type != 'A' or globally when loanSummary is active) -->
    <div class="col-md-12 mb-2 alert loanSummary" *ngIf="Type != 'A'"
      [ngClass]="PLoanDetail && PLoanDetail.Watermark_Status != null && PLoanDetail.Watermark_Status != undefined ? 'alert-danger' : ''"
      style="padding: 0.625rem 1rem !important; margin: 0px 0px 0.75rem 0px !important;">
      <!-- Row 1: Branch, Borrower, Relation, Product -->
      <div class="row m-0 mt-0">
        <div class="col-md-3">
          <div class="detail-item">
            <span class="detail-label">Branch</span>
            <span class="detail-value">{{ loanSummary.Branch }}</span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="detail-item">
            <span class="detail-label">Borrower Name</span>
            <span class="detail-value">{{ loanSummary.Customer }}</span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="detail-item">
            <span class="detail-label">Relation</span>
            <span class="detail-value">{{ loanSummary.RelationName }}</span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="detail-item">
            <span class="detail-label">Product</span>
            <span class="detail-value">{{ loanSummary.Product }}</span>
          </div>
        </div>
      </div>
      
      <!-- Row 2: Loan details (shown if Type == 'L') -->
      <div class="row m-0 border-top-divider mt-2 pt-2" *ngIf="Type == 'L'">
        <div class="col-md-3">
          <div class="detail-item">
            <span class="detail-label">Loan No</span>
            <span class="detail-value highlight-val">{{ loanSummary.LoanNo }}</span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="detail-item">
            <span class="detail-label">Loan Date</span>
            <span class="detail-value">{{ loanSummary.LoanDate }}</span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="detail-item">
            <span class="detail-label">Loan Amount</span>
            <span class="detail-value">₹{{ loanSummary.LoanAmount }}</span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="detail-item">
            <span class="detail-label">Tenure</span>
            <span class="detail-value">{{ loanSummary.Tenure }} Months</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Side-by-side details shown if Type == 'A' -->
    <div class="row col-md-12 m-0 mb-2" *ngIf="Type == 'A'">
      <!-- Left side: Partner Loan Details -->
      <div class="col-md-6 mb-2 pr-1">
        <div class="alert loanSummary h-100"
          [ngClass]="PLoanDetail && PLoanDetail.Watermark_Status != null && PLoanDetail.Watermark_Status != undefined ? 'alert-danger' : ''"
          style="padding: 0.625rem 1rem !important; margin: 0px !important;">
          <div class="row m-0">
            <div class="col-md-12 text-center mb-3">
              <h1 class="fs-14 m-0 font-weight-700 text-uppercase" style="letter-spacing: 0.5px; color: var(--theme-primary) !important;">Partner Loan Details</h1>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">Loan No</span>
                <span class="detail-value highlight-val">{{ PLoanDetail ? PLoanDetail.PLoanAcNo : '' }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">Loan Date</span>
                <span class="detail-value">{{ PLoanDetail ? PLoanDetail.Partner_Loan_Date : '' }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">Loan Amount</span>
                <span class="detail-value">{{ PLoanDetail ? PLoanDetail.NetFinance : '' }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">Expiry Date</span>
                <span class="detail-value">{{ PLoanDetail ? PLoanDetail.ExpiryDate : '' }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">EMI Amount</span>
                <span class="detail-value">{{ PLoanDetail ? PLoanDetail.EMIAmount : '' }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">No of Instl</span>
                <span class="detail-value">{{ PLoanDetail ? PLoanDetail.No_Of_Instl : '' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right side: Customer Loan Details -->
      <div class="col-md-6 mb-2 pl-1">
        <div class="alert loanSummary h-100"
          [ngClass]="PLoanDetail && PLoanDetail.Watermark_Status != null && PLoanDetail.Watermark_Status != undefined ? 'alert-danger' : ''"
          style="padding: 0.625rem 1rem !important; margin: 0px !important;">
          <div class="row m-0">
            <div class="col-md-12 text-center mb-3">
              <h1 class="fs-14 m-0 font-weight-700 text-uppercase" style="letter-spacing: 0.5px; color: var(--theme-primary) !important;">Customer Loan Details</h1>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">Loan No</span>
                <span class="detail-value highlight-val">{{ loanSummary.LoanNo }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">Loan Date</span>
                <span class="detail-value">{{ loanSummary.LoanDate }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">Loan Amount</span>
                <span class="detail-value">{{ loanSummary.LoanAmount }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">Expiry Date</span>
                <span class="detail-value">{{ loanSummary.ExpiryDate }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">EMI Amount</span>
                <span class="detail-value">{{ loanSummary.EMIAmount }}</span>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="detail-item">
                <span class="detail-label">No of Instl</span>
                <span class="detail-value">{{ loanSummary.No_Of_Instl }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mat-tab-group class="Loan_Layout" *ngIf="isGetDetail" [selectedIndex]="currentTab"
    (selectedTabChange)="onTabChange($event)">
    <mat-tab>
      <ng-template mat-tab-label><span>Loan Info</span></ng-template>
      <ng-template matTabContent>
        <app-partner-loan-info [PageType]="Type" [ApplicationId]="LoanId" [isNew]="isNew" [loanSummary]="loanSummary"
          (action)="onChildAction($event)">
        </app-partner-loan-info>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="lastFillTab<1">
      <ng-template mat-tab-label><span>Account Info</span></ng-template>
      <ng-template matTabContent>
        <app-partner-account-info [PageType]="Type" [loanSummary]="loanSummary"
          (action)="onChildAction($event)"></app-partner-account-info>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="lastFillTab<2">
      <ng-template mat-tab-label><span>Amortization Chart</span></ng-template>
      <ng-template matTabContent>
        <app-partner-amortization [PageType]="Type" [loanSummary]="loanSummary"
          (action)="onChildAction($event)"></app-partner-amortization>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="lastFillTab<3 || PLoan_ID == 0">
      <ng-template mat-tab-label><span>DV Detail</span></ng-template>
      <ng-template matTabContent>
        <app-partner-dv-detail [PageType]="Type" [loanSummary]="loanSummary"
          (action)="onChildAction($event)"></app-partner-dv-detail>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="Type == 'A'">
      <ng-template mat-tab-label><span>Loan Statement</span></ng-template>
      <ng-template matTabContent>
        <app-patner-loan-statement [PageType]="Type" [loanSummary]="loanSummary"
          (action)="onChildAction($event)"></app-patner-loan-statement>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</section>